import uniq from 'lodash.uniq';
import isNil from 'lodash.isnil';
import isEmpty from 'lodash.isempty';
import { isIncorrectWord } from '../../../../../utils/shared/trcUtils';
import TRC_CONTENT_MARK_STYLE_CLASSES_MAP from '../../../../../constants/shared/ClassNamesToRulesMapper';

export const getNoteColor = (wordData, isBorder) => {
    const { selfCorrected, substituted, note } = wordData;
    if ((selfCorrected && !isNil(note)) || (selfCorrected && substituted)) {
        return isBorder ? 'green-border' : 'sc';
    }
    if (isIncorrectWord(wordData)) {
        return isBorder ? 'red-border' : 'error';
    }
    return 'blac-border';
};

export const getRightClassName = wordData => {
    let classNames = '';
    Object.keys(TRC_CONTENT_MARK_STYLE_CLASSES_MAP).forEach(className => {
        classNames += TRC_CONTENT_MARK_STYLE_CLASSES_MAP[className](wordData)
            ? `${className} `
            : '';
    });
    const finalClassNames = uniq(classNames.split(' ')).join(' ');
    const repeatedClassName = wordData.repeated ? 'trc-color-blue' : '';
    return isEmpty(finalClassNames) ? repeatedClassName : finalClassNames;
};
